module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Midi-e1c63544fba9d3a44df6a4e8d794c685c8963aadf32d515edfa674ab7d06530a.svg";